import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-70f5e0d0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "row g-5 gx-xxl-12" }
const _hoisted_2 = { class: "col-xxl-8 col-sm-12 col-xs-12" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "me-4 mx-2" }, [
  /*#__PURE__*/_createElementVNode("img", { src: "/media/svg/files/shield-check.svg" })
], -1))
const _hoisted_4 = { class: "d-flex flex-column text-light m-auto fw-bold" }
const _hoisted_5 = ["href"]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "/media/svg/files/user-shield-dark.svg",
  style: {"width":"15px","height":"13px"}
}, null, -1))
const _hoisted_7 = { class: "text mx-3" }
const _hoisted_8 = { class: "col-xxl-4 col-sm-12 col-xs-12" }
const _hoisted_9 = { class: "alert alert-dismissible w-100 privacy-bg" }
const _hoisted_10 = { class: "d-flex flex-row mb-5" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "me-4 mb-5 mb-sm-0 mx-2 pt-2" }, [
  /*#__PURE__*/_createElementVNode("img", { src: "/media/svg/files/shield-check.svg" })
], -1))
const _hoisted_12 = { class: "d-flex flex-column text-light privacy-text-bg fw-light" }
const _hoisted_13 = ["href"]
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "/media/svg/files/user-shield-dark.svg",
  style: {"width":"15px","height":"13px"}
}, null, -1))
const _hoisted_15 = { class: "text mx-3 text-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Wizard = _resolveComponent("Wizard")!
  const _component_WidgetBlog = _resolveComponent("WidgetBlog")!
  const _component_WidgetPatientStatus = _resolveComponent("WidgetPatientStatus")!
  const _component_WidgetCaseManager = _resolveComponent("WidgetCaseManager")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: _normalizeClass(["alert alert-dismissible d-flex flex-column flex-sm-row w-100 privacy-bg", { 'd-none': _ctx.ismobile }]),
        style: {"height":"48px"}
      }, [
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("span", null, _toDisplayString(_ctx.$t("Your personal data is fully confidential and 100% secure")), 1)
        ]),
        _createElementVNode("a", {
          href: _ctx.privacyPolicyUrl,
          target: "_blank",
          type: "button",
          class: "privacy-btn-inline position-absolute position-sm-relative btn btn-light btn-sm ms-sm-auto privacy-btn-bg"
        }, [
          _hoisted_6,
          _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.$t("Privacy Policy")), 1)
        ], 8, _hoisted_5)
      ], 2),
      _createVNode(_component_Wizard, {
        onRefreshData: _ctx.updateComponents,
        "widget-classes": "",
        ref: "refWizard"
      }, null, 8, ["onRefreshData"]),
      _createVNode(_component_WidgetBlog, { "widget-classes": "" })
    ]),
    _createElementVNode("div", _hoisted_8, [
      _withDirectives(_createVNode(_component_WidgetPatientStatus, {
        ref: "refWidgetPatientStatus",
        "widget-classes": " mb-5 mb-xl-8 card "
      }, null, 512), [
        [_vShow, !_ctx.ismobile]
      ]),
      _createVNode(_component_WidgetCaseManager, {
        ref: "refWidgetCaseManager",
        "widget-classes": " mb-xl-4"
      }, null, 512)
    ]),
    _createElementVNode("div", {
      class: _normalizeClass(["col-xxl-4 col-sm-12 col-xs-12", { 'd-none': !_ctx.ismobile }])
    }, [
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, [
          _hoisted_11,
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("span", null, _toDisplayString(_ctx.$t("Your personal data is fully confidential and 100% secure")), 1)
          ])
        ]),
        _createElementVNode("a", {
          href: _ctx.privacyPolicyUrl,
          target: "_blank",
          type: "button",
          class: "btn btn-light btn-sm ms-sm-auto w-100"
        }, [
          _hoisted_14,
          _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.$t("Privacy Policy")), 1)
        ], 8, _hoisted_13)
      ])
    ], 2)
  ]))
}